import React from "react";
import { Link } from "react-router-dom";

const GuidancePage = () => {
  return (
    <div
      style={{
        padding: "2rem",
        maxWidth: "900px",
        margin: "0 auto",
        lineHeight: "1.7",
        color: "#1a1a1a",
      }}
    >
      <h1 style={{ fontSize: "2rem", marginBottom: "1.5rem", textAlign: "center" }}>
        User Guidance – How to Use UK School Rankings
      </h1>

      {/* Data Source Notice */}
      <section
        style={{
          marginBottom: "2rem",
          backgroundColor: "#f0f8ff",
          padding: "1rem",
          borderRadius: "6px",
        }}
      >
        <p>
          <strong>Note:</strong> All data on <strong>UK School Rankings</strong> is sourced from official
          government datasets across England, Scotland, Wales, and Northern Ireland. This ensures accurate,
          verified, and up-to-date school performance information.
        </p>

        <div style={{ color: "#264653", marginBottom: "1rem" }}>
          <h1 style={{ fontSize: "1rem", fontWeight: "600", marginBottom: "0.5rem" }}>
            Top Schools (Added data for group of subjects)
          </h1>
          <p className="last-updated" style={{ fontSize: "0.85rem", margin: 0 }}>
            Last updated: <strong>{new Date().toLocaleDateString("en-GB")}</strong>
          </p>
        </div>


        <p style={{ marginTop: "0.5rem" }}>
          If you would like to have your school represented here, please <strong>contact me</strong>.
        </p>

      </section>

      {/* Step 1 */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>🎯 Step 1: Choose a Dataset</h2>
        <p>
          Start by selecting a dataset, such as <em>UK Schools (GCSE 2025)</em>. Each dataset contains
          schools for a specific region or data type.
        </p>
      </section>

      {/* Step 2 */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>🧩 Step 2: Apply Filters</h2>
        <p>
          Use the filters panel (usually on the left side or top bar) to narrow your search. You can filter schools by:
        </p>
        <ul style={{ paddingLeft: "1.2rem" }}>
          <li>🏫 <strong>Region or Country</strong> — England, Scotland, Wales, or Northern Ireland</li>
          <li>📚 <strong>School Type</strong> — Government, Independent, Grammar, etc.</li>
          <li>👧👦 <strong>Gender</strong> — Mixed, Boys, or Girls</li>
          <li>📈 <strong>Performance Rank</strong> — Top-performing or specific GCSE results</li>
        </ul>
        <p>When you change a filter, the results update instantly — no need to reload the page.</p>
      </section>

      {/* Step 3 */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>🔍 Step 3: Search for a School</h2>
        <p>Use the search box to quickly find a school by name. As you type, results will update in real time.</p>
        <ul style={{ paddingLeft: "1.2rem" }}>
          <li>
            Click on a school name in the results list — it will automatically <strong>highlight the school on the interactive map</strong>.
          </li>
          <li>Hover over it to view details such as performance score and rank.</li>
          <li>
            Want to save the list? Click <strong>Download</strong> to export the table as PDF or Excel.
          </li>
        </ul>
      </section>

      {/* Step 4 */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>🗺️ Step 4: Explore the Map</h2>
        <p>
          The interactive map shows all schools as pins. You can zoom, pan, and click on any pin to view
          the school’s name, performance, and rank.
        </p>
        <p>
          When you filter or search, the map will automatically adjust to show only the relevant schools — allowing
          you to quickly spot geographic trends or top-performing areas.
        </p>
      </section>

      {/* Step 5 */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>📥 Step 5: Download Data</h2>
        <p>You can download your filtered results for research or reporting purposes:</p>
        <ul style={{ paddingLeft: "1.2rem" }}>
          <li>Click the <strong>Download</strong> button beneath the results table.</li>
          <li>Select your preferred file format — PDF or Excel.</li>
          <li>Open it in <em>Excel</em>, <em>Google Sheets</em>, or your favourite data analysis tool.</li>
        </ul>
      </section>

      

      {/* Feedback */}
      <section style={{ marginBottom: "2rem" }}>
        <h2 style={{ fontSize: "1.4rem", marginBottom: "0.5rem" }}>📬 Feedback & Support</h2>
        <p>
          Suggestions, questions, or requests for additional data (like A-level rankings)? Want your school featured? 
          Connect with me on{" "}
          <a
            href="https://www.linkedin.com/in/denisvk-it/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#007acc" }}
          >
            LinkedIn
          </a>.
        </p>
      </section>

      <div style={{ textAlign: "center", marginTop: "2.5rem" }}>
        <Link
          to="/"
          style={{
            backgroundColor: "#007acc",
            color: "white",
            padding: "0.7rem 1.4rem",
            borderRadius: "6px",
            textDecoration: "none",
            fontWeight: "bold",
          }}
        >
          ← Back to Rankings
        </Link>
      </div>
    </div>
  );
};

export default GuidancePage;
